import React from 'react'
import './Advertisement.css';

export const Advertisement = () => {
    return (
        <div>
            {/* <div className="marquee-container">
                <div className="marquee-text">
                    Welcome to VTAS - A Firm of Chartered Accountants ! - Now We are in Madampe !
                </div>
            </div> */}
        </div>
    )
}
